export const routePathMapping: { routePath: string[], moduleName: string }[] = [
    {
        routePath: ['home', 'company-details'],
        moduleName: 'home'
    }, {
        routePath: ['data-stewardship', 'company-details'],
        moduleName: 'datastewardship'
    }, {
        routePath: ['search', 'company-details'],
        moduleName: 'search'
    }, {
        routePath: ['bulk-match'],
        moduleName: 'fulfillmentuser'
    }, {
        routePath: ['reports'],
        moduleName: 'reports'
    }, {
        routePath: ['admin-console', 'export'],
        moduleName: 'settings'
    }, {
        routePath: ['about-us', 'hierarchy-management'], //TODO: Remove 'hierarchy-management' from here
        moduleName: 'aboutus'
    }
];

export function getRoutePath(moduleName: string): string[] {
    return routePathMapping.find((item) => item.moduleName === moduleName)?.routePath ?? [];
}